import api from '@/utils/api';
import { cache } from 'react';
import cfApi from './cfApi';
import { notFound } from 'next/navigation';

export const revalidate = 3600;
let cacheData = new Map();

export const getGlobal = cache(async ({ locale }) => {
	const { data } = await api.get('global-data', locale);

	return data;
});

export const getPage = cache(async ({ slug, locale }) => {
	const { data } = await api.get(`pages/${slug}`, locale).catch(() => {
		notFound();
	});

	return data;
});

export const getService = cache(async ({ slug, locale }) => {
	const { data } = await api.get(`service/${slug}`, locale).catch(() => {
		notFound();
	});

	return data;
});

export const getMeta = cache(async ({ type = 'page', slug, locale }) => {
	const data = await api.get(`meta/${type}/${slug}`, locale);
	return data;
});

export const getPortfolioShortList = async ({ lang, serviceType }) => {
	return await cfApi.getContentTypePosts('portfolio', { limit: 6, 'fields.serviceType': serviceType }, lang);
};

export const getAwards = async ({ lang }) => {
	return await api.get('awards', lang).then((res) => res.data);
};

export const getHomeTestimonials = async ({ lang }) => {
	return await api.get('home-testimonials', lang).then((res) => res.data);
};

let funcs = {
	getPortfolioShortList,
	getAwards,
	getHomeTestimonials,
};

export function fetchSectionData({ name, lang, params = {} }) {
	const dataKey = `${lang}-${name}-${JSON.stringify(params)}`;

	if (!cacheData.has(dataKey)) {
		cacheData.set(dataKey, funcs[name]?.({ lang, ...params }));
	}

	return cacheData.get(dataKey);
}
